import { useApi } from './use-api-call';
import { ProductDTO } from './product-api';

export const useSearchProductSpecificationApi = () =>
    useApi<{
        productSpecifications: ProductSpecificationDTO[];
        products: ProductDTO[];
        allowEdit: boolean;
    }>('/product-specification/search-product-specification');

export const useGetProductSpecificationApi = () =>
    useApi<{ productSpecification: ProductSpecificationDTO; allowEdit: boolean }>(
        '/product-specification/get-product-specification/{id}'
    );

export const useSaveProductSpecificationApi = () =>
    useApi<{ productSpecification: ProductSpecificationDTO }>(
        '/product-specification/save-product-specification'
    );

export const useDeleteProductSpecificationApi = () =>
    useApi('/product-specification/delete-product-specification/{id}');

export interface ProductSpecificationDTO {
    id: number;
    productId: number;
    key: string;
    value: string;
}
